import { render, staticRenderFns } from "./task-create.vue?vue&type=template&id=725e4984&"
import script from "./task-create.vue?vue&type=script&lang=js&"
export * from "./task-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports